import translate from 'i18n-js';

import en from './translations/en.json';

translate.locale = 'en';
translate.fallbacks = true;
translate.translations = { en };

export default translate;
